import Store from '@/store'
import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'
import i18n from '@/i18n'

export default {
  resellerConnection: null,
  connectToResellerHub () {
    this.resellerConnection = new HubConnectionBuilder()
      // TODO Replace hardcoded url with process.env.VUE_APP_HUBURL & add this to the .env files
      .withUrl(process.env.VUE_APP_HUBURL, {
        accessTokenFactory: () => Store.state.security.user.access_token,
      })
      .configureLogging(LogLevel.Information)
      .build()

    // Registration callback
    this.resellerConnection.on('ResellerHubRegistered', function () {
      console.log('signalR - Registered on the reseller hub')
    })

    // Subscription Communication Handlers
    this.resellerConnection.on('subscriptionCreated', function (model) {
      console.log('signalR - SubscriptionCreated: ', model)
      Store.dispatch('AddNotification', model)
      Store.dispatch('SetSnackBarMessage', {
        message: i18n.t('Services.Subscriptions.Messages.SubscriptionCreated'),
        color: 'success',
      })
      Store.dispatch('SilentRefreshSubscription', model.subscriptionId)
    })
    this.resellerConnection.on('SubscriptionUpdated', function (model) {
      console.log('signalR - SubscriptionUpdated: ', model)
      Store.dispatch('AddNotification', model)
      Store.dispatch('SilentRefreshSubscription', model.subscriptionId)
    })
    this.resellerConnection.on('SubscriptionCancelled', function (model) {
      console.log('signalR - SubscriptionCancelled: ', model)
      Store.dispatch('AddNotification', model)
      Store.dispatch('UnloadSubscription', model.subscriptionId)
    })

    this.resellerConnection
      .start()
      .then(() => {
        console.log('signalR - ResellerHub Started')
      })
      .catch(function (err) {
        return console.error(err.toString())
      })
  },
  disconnectFromHubs () {
    this.disconnectFromResellerHub()
  },
  disconnectFromResellerHub () {
    if (this.resellerConnection === null) {
        return
    }
    this.resellerConnection.stop().done(function () {
      console.log('Disconnected from reseller hub')
      this.resellerConnection = null
    })
  },
}
